export const VideoCamOff = ({ ...props }: React.SVGProps<SVGSVGElement>) => (
  <svg width={props.width} height={props.height} viewBox='0 0 22 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M2.70703 0.292969L1.29297 1.70703L2.58594 3H2C0.897 3 0 3.897 0 5V15C0 16.103 0.897 17 2 17H15C15.446 17 15.8545 16.8492 16.1875 16.6016L19.293 19.707L20.707 18.293L2.70703 0.292969ZM8.26367 3L10.2637 5H15V9.73438L18.7246 13.4609L22 16.0801V3.91992L17 7.91992V5C17 3.897 16.103 3 15 3H8.26367ZM2 5H4.58594L14.5859 15H2V5ZM20 8.08008V11.9199L17.6016 10L20 8.08008Z'
      fill={props.color}
    />
  </svg>
);
